<div class="reading-progress" [style.width.%]="scrollProgress"></div>
<img [src]="'assets/acc-auth0.jpg'" class="acc-logo" alt="ACC Logo" />
<div class="page-title">ACC DATA HUB END USER LICENSE AGREEMENT</div>
<div class="agreement">
  <div class="license-agreement" (scroll)="onScroll($event)">
    @if (isLoading) {
      <div class="loader-container">
        <div class="loader">
          <div class="loader-spinner"></div>
          <p class="loader-text">Loading license agreement...</p>
        </div>
      </div>
    } @else {
      @if (eulaType === 1) {
        <app-default-eula></app-default-eula>
      } @else if (eulaType === 2) {
        <app-deeproots-eula></app-deeproots-eula>
      } @else if (eulaType === 3) {
        <app-free-trial-eula></app-free-trial-eula>
      }
      <div class="agreement-footer">
        <label class="checkbox-container"
          ><input
            type="checkbox"
            [checked]="isChecked"
            (change)="isChecked = !isChecked"
          /><span class="checkmark"></span
          ><span class="label-text">
            <span class="required-text">*</span>
            I have read and agree to the terms and conditions above
          </span></label
        >
        <div
          class="agreement-button"
          [class.disabled]="!isChecked"
          [style.pointer-events]="!isChecked ? 'none' : 'auto'"
        >
          <a [href]="auth0RedirectUrl"> Agree </a>
        </div>
      </div>
    }
  </div>
</div>
